import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import ViewCustomer from '../Master/ViewCustomer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { format } from 'date-fns';

const SalesReport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const paymentTableRef = useRef(null);

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start, end] = dates;
      setFromDate(format(start, 'yyyy-MM-dd'));
      setToDate(format(end, 'yyyy-MM-dd'));
    } else {
      setFromDate('');
      setToDate('');
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      window.location.href = '/login';
      return;
    }

    const $paymentTable = $(paymentTableRef.current);
    if ($.fn.DataTable.isDataTable($paymentTable)) {
      $paymentTable.DataTable().destroy();
    }

    const paymentTable = $paymentTable.DataTable({
      serverSide: true,
      processing: true,
      scrollX: true,
      autoWidth: false,
      ajax: {
        url: `${config.api_url}/ws-sales-payment-report-list`,
        type: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: (d) => ({
          ...d,
          searchByFromdate: fromDate,
          searchByTodate: toDate,
          searchValue,
        }),
        dataSrc: 'data',
      },
      columns: [
        { data: 'payment_date' },
        { data: 'reference_no' },
        {
          data: 'job_ref',
          className: 'sales-report-col-jobref',
          render: (data) => {
            const value = data || '';
            const esc = String(value)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
            return `<div class="sales-report-cell-clip" title="${esc}">${esc}</div>`;
          },
        },
        {
          data: 'company_name',
          className: 'sales-report-col-customer',
          render: (data, type, row) => {
            const name = data || '';
            const esc = String(name)
              .replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
            return `<a href="#" class="viewbtn sales-report-customer-link" data-id="${row.customer_id}" data-bs-toggle="modal" data-bs-target="#view_customer" title="${esc}"><span class="sales-report-customer-text">${esc}</span></a>`;
          },
        },
        { data: 'transaction_ref' },
        { data: 'payment_amount', className: 'text-end' },
        { data: 'remaining_balance', className: 'text-end' },
        { data: 'bank_name' },
        { data: 'details' },
      ],
      columnDefs: [
        { targets: 2, width: '5%' },
        { targets: 3, width: '22%' },
      ],
      pageLength: 50,
      lengthMenu: [10, 25, 50, 100],
      ordering: false,
    });

    return () => {
      paymentTable.destroy();
    };
  }, [fromDate, toDate, searchValue]);

  return (
    <div>
      <Header />
      <ViewCustomer />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard"><i className="fa fa-home" /></Link> &gt;
              <Link to="/Dashboard">Dashboard</Link> &gt;
              <span className="last-crumb">Sales Payment History</span>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="dashboard">
                <div className="topsearch-area">
                  <div className="row">
                    <div className="col-lg-5 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-4 col-form-label">Order ID / Customer</label>
                        <div className="col-sm-8">
                          <input
                            type="text"
                            className="search-area form-control"
                            placeholder="Search"
                            autoComplete="off"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="row mb-2">
                        <label className="col-sm-3 col-form-label">Date Range</label>
                        <div className="col-sm-9">
                          <DateRangePicker
                            value={[fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null]}
                            onChange={handleDateChange}
                            format="dd/MM/yyyy"
                            editable={false}
                            placeholder="DD/MM/YYYY - DD/MM/YYYY"
                            cleanable
                            style={{ width: '100%' }}
                            onClean={() => {
                              setFromDate('');
                              setToDate('');
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vertical-scrl-wrapper common-table order-history-table sales-payment-report-scroll" id="style-3">
                  <table className="table table-bordered dataTable sales-payment-report-table" id="salesPaymentTable" ref={paymentTableRef}>
                    <thead>
                      <tr>
                        <th>Payment Date</th>
                        <th>Order ID</th>
                        <th>Job Ref</th>
                        <th>Customer</th>
                        <th>Transaction Ref</th>
                        <th>Amount Received</th>
                        <th>Balance</th>
                        <th>Bank</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody />
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SalesReport;
